import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import * as Sentry from '@sentry/angular';

registerLicense(environment.licenseKey);

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.environment,
  release: environment.release || undefined,
  enabled: !!environment.sentryDsn,
  ignoreErrors: [
    // Auth/session — expected user behavior, not bugs
    'Not authenticated',
    'NotAuthenticated',
    'No accessToken found',
    'session has expired',
    'Invalid login',
    'Incorrect email or password',
    // Network — backend downtime, not frontend bugs
    'Service Temporarily Unavailable',
    '504 Gateway',
    'getaddrinfo EAI_AGAIN',
    'Unable to connect to the server',
    'Failed to fetch',
    'Load failed',
    'NetworkError when attempting to fetch resource',
  ],
});


if (environment.environment == 'prod') {
  enableProdMode();
}



platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
